/**
 * V2批量打印结果下载器，通过POST请求获取文件流并触发浏览器保存。
 */
export class PrintResultDownloader {
  constructor(download) {
    if (!download) {
      throw new Error('download function is required')
    }
    this.download = download
  }

  async open(task) {
    if (task && task.resultDownloadUrl) {
      return this.openDirectUrl(task)
    }
    const file = await this.downloadBlob(task)
    return this.openBlob(task, file)
  }

  async openDirectUrl(task) {
    // The poll has finished away from the original click gesture. A hidden
    // iframe avoids popup blockers while letting the file service return the
    // attachment response directly.
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.setAttribute('data-print-result-download', task.printId || '')
    iframe.src = task.resultDownloadUrl
    document.body.appendChild(iframe)
    setTimeout(() => iframe.remove(), 60 * 1000)
    return {
      blob: new window.Blob(),
      name: this.fileName(task),
      directDownload: true
    }
  }

  openBlob(task, file) {
    const objectUrl = URL.createObjectURL(file.blob)
    const anchor = document.createElement('a')
    anchor.href = objectUrl
    anchor.download = file.name
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10000)
    return file
  }

  async downloadBlob(task) {
    if (!task.resultFileId) {
      const error = new Error(task.errorMsg || 'Print task has no result file')
      error.printTask = task
      throw error
    }
    const response = await this.download(task.printId)
    const blob = response && response.data ? response.data : response
    if (!(window.Blob && blob instanceof window.Blob)) {
      throw new Error('打印结果下载失败')
    }
    return { blob, name: this.fileName(task, response) }
  }

  fileName(task, response) {
    const disposition = response && response.headers ? response.headers['content-disposition'] : ''
    const match = disposition && disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)/i)
    if (match && match[1]) {
      try {
        return decodeURIComponent(match[1])
      } catch (e) {
        return match[1]
      }
    }
    return task.resultFileName || 'print-result'
  }

  toLegacyFileResult(task) {
    return {
      data: { id: task.resultFileId, fileId: task.resultFileId, name: task.resultFileName },
      printTask: task
    }
  }
}
